// @ts-strict-ignore
import React, { useContext } from 'react';
import {
  ButtonSize, ButtonVariant, useUniqueId,
} from '@usealloy/component-library';
import type { RuleBuilderRule } from 'flow/service/rules';
import { getLocalizedIndex, groupType } from 'flow/service/rules';
import { useAppDispatch, useAppSelector } from '~/store/reduxHooks';
import { groupRulesInRuleStateThunk, resetRuleBuilderPendingGroupStateThunk } from 'flow/store/redux/thunks';
import { RuleBuilderContext } from '../../../context';
import {
  StyledHoverButton,
  StyledPendingClosingParenthesisContainer,
  StyledPendingClosingParenthesisDropdown,
} from './styles';
import { pendingCloseGroupOptions } from './constants';
import { isInstanceIndexMatch } from '../helpers';
import { selectRuleBuilderHoveredRuleIndex } from 'flow/store/redux/selectors';
import RuleMultiSelect from '../RuleMultiSelect';

type PendingCloseGroupDropdownProps = {
  rule: RuleBuilderRule;
  index: number;
};

export default function PendingCloseGroupDropdown(
  { rule, index }: PendingCloseGroupDropdownProps,
) {
  const dispatch = useAppDispatch();
  const hoveredRuleIndex = useAppSelector(selectRuleBuilderHoveredRuleIndex);
  const {
    sourceAction,
    ruleTree,
    keyboardFocus,
    instanceId,
    containerType,
  } = useContext(RuleBuilderContext);
  const id = useUniqueId('close-group-dropdown');

  const isHovered = isInstanceIndexMatch(hoveredRuleIndex, instanceId, index);

  const onChange = option => {
    switch (option.value) {
      case 'close': {
        dispatch(
          groupRulesInRuleStateThunk({
            action: sourceAction,
            treeRoot: ruleTree,
            insertProps: {
              groupType: groupType.or,
              endIndex: getLocalizedIndex(rule.data.path),
            },
          }),
        );

        dispatch(resetRuleBuilderPendingGroupStateThunk(sourceAction.publicId));
        break;
      }
      case 'cancel':
      default: {
        dispatch(resetRuleBuilderPendingGroupStateThunk(sourceAction.publicId));
        break;
      }
    }
  };

  return (
    <StyledPendingClosingParenthesisContainer containerType={containerType}>
      <StyledPendingClosingParenthesisDropdown containerType={containerType}>
        <RuleMultiSelect
          options={pendingCloseGroupOptions}
          onChange={onChange}
          openMenuOnFocus
          placeholder=")"
          selectedOptions={null}
          id={id}
          isMulti={false}
          isNaked
          useFixedMenuPosition
        />
      </StyledPendingClosingParenthesisDropdown>
      {
        isHovered && (
          <StyledHoverButton
            id="close-group-hover-button"
            size={ButtonSize.xsmall}
            variant={ButtonVariant.tertiary}
            onClick={() => {
              keyboardFocus.setFocusedElement(id);
              keyboardFocus.focus();
            }}
          >
            close group here
          </StyledHoverButton>
        )
      }
    </StyledPendingClosingParenthesisContainer>
  );
}
